<div class="content">
  <div class="cardview-card">
    <div class="post-container">
      <div class="post-thumb"><img *ngIf="cardrow.image == null" src="assets/image/no-image-icon.png"/>
        <img *ngIf="cardrow.image != null" [src]="cardrow.image"/></div>
      <div class="post-content">
          <h3 class="post-title">{{cardrow.pk}} - {{cardrow.title}}</h3>
          <ng-content select="[subtitle]"></ng-content>
      </div>
      <div class="post-complemento">
        <ng-content select="[complemento]"></ng-content>
      </div>
      <div class="options" (click)="onClick($event)">
        <button nz-button nzType="text" nzShape="circle" nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click">
          <nz-icon nzType="more"></nz-icon>
        </button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item *ngFor="let item of options" (click)="openDialog($event,item)">
              <generic-icon [iconName]="item.icon" type="google"></generic-icon>
              <span class="item-desc">{{item.desc}}</span>
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </div>
  </div>
</div>
